exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.order_history_locations_select .select-wrapper select{\n  padding-left: 5px;\n  color: #000;\n}\n.order_history_locations_select .select-wrapper select:focus ~ label, .select-wrapper select:not(.empty) ~ label {\n  top: 0;\n  font-size: 12px;\n  left: 0;\n  color: #4dba87;\n  display: none;\n}\n.order_history_locations_select .select-wrapper.relative:after{\n  top: 1.2rem;\n}\n", ""]);

// exports
